import React from 'react';
import {
  Box,
  Button,
  Link as MuiLink,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { ContentUseCase } from '../../corelogic/usecases/ContentUseCase';
import { useLanguage } from '../../shared/contexts/LanguageContext';
import { useLocalizedPath } from '../../shared/hooks/useLocalizedPath';
import { getSecondaryButtonStyles } from '../../shared/styles';
import { SEO } from './SEO';
import { Section, PageHeader } from './PageSection';
import { LegalBlock, LegalHeading, LegalList } from './LegalSectionBody';

const contentUseCase = new ContentUseCase();

export const CookiePage: React.FC = () => {
  const theme = useTheme();
  const { language } = useLanguage();
  const lp = useLocalizedPath();
  const { cookies } = contentUseCase.getLegalContent(language);

  return (
    <Box>
      <SEO page="cookies" />

      <PageHeader title={cookies.title} subtitle={cookies.what.description} />

      <Section maxWidth="md">
        <LegalBlock>
          <LegalHeading>{cookies.table.title}</LegalHeading>
          <TableContainer component={Paper} elevation={0} sx={{ border: `1px solid ${theme.palette.divider}` }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600 }}>{cookies.table.headers.name}</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>{cookies.table.headers.purpose}</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>{cookies.table.headers.duration}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {cookies.table.rows.map((row) => (
                  <TableRow key={row.name}>
                    <TableCell sx={{ fontFamily: 'monospace', verticalAlign: 'top' }}>{row.name}</TableCell>
                    <TableCell>{row.purpose}</TableCell>
                    <TableCell sx={{ verticalAlign: 'top' }}>{row.duration}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </LegalBlock>

        <LegalBlock>
          <LegalHeading>{cookies.decline.title}</LegalHeading>
          <Typography variant="body1" paragraph>
            {cookies.decline.description}
          </Typography>
          <LegalList items={cookies.decline.effects} />
        </LegalBlock>

        <LegalBlock>
          <LegalHeading>{cookies.manage.title}</LegalHeading>
          <Typography variant="body1" paragraph>
            {cookies.manage.description}
          </Typography>
          <Button component={Link} to={lp('/cookie-settings')} sx={getSecondaryButtonStyles(theme)}>
            {cookies.manage.button}
          </Button>
        </LegalBlock>

        <LegalBlock last>
          <LegalHeading>{cookies.contact.title}</LegalHeading>
          <Typography variant="body1" paragraph>
            {cookies.contact.description}
          </Typography>
          <MuiLink href={`mailto:${cookies.contact.email}`} sx={{ color: 'primary.dark', fontWeight: 600 }}>
            {cookies.contact.email}
          </MuiLink>
        </LegalBlock>
      </Section>
    </Box>
  );
};
